import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalContainer = styled(Modal).attrs({
  centered: true,
})`
  color: ${({ theme }) => theme.textColor};
`;
